module.exports = __webpack_public_path__ + "img/product-ketang-jbg-06.55f56e49.png";